/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useMemo, memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
// @ts-expect-error no typings
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { isUninitialized, isLoading, getData } from 'calling-lifecycle-internal/async-flux-utils/operators/getApiProperties';
import { getPersistedCallProvider } from 'calling-lifecycle-internal/utils/getLocalCallSettings';
import { getIsProviderHubSpot } from 'calling-lifecycle-internal/call-provider/operators/getIsTwilioBasedCallProvider';
import { getPhoneNumbers, getConnectAccountNumbers, getHubSpotCallingEnabled } from '../../callee-omnibus/operators/settingsOmnibusResultGetters';
import GlobalCallingDisabled from './GlobalCallingDisabled';
import { isCallingFree } from 'calling-internal-common/utils/CallingSalesPro';
import UnlockCallingItem from 'calling-orchestration-shared-library/unlock-calling/components/UnlockCallingItem';
import { getCallingMinutesPerPortal } from 'calling-internal-common/utils/getCallingLimits';
import { CommunicatorLogger } from 'calling-lifecycle-usage-tracker/callingTracker';
import CallNumberSkeletons from './CallNumberSkeletons';
import { jsx as _jsx } from "react/jsx-runtime";
function CallingOnboardingActivityCreator({
  asyncSettingsOmnibus,
  children,
  scopes,
  limits,
  appIdentifier
}) {
  const isOmnibusDataUninitialized = isUninitialized(asyncSettingsOmnibus);
  const isOmnibusDataLoading = isLoading(asyncSettingsOmnibus);
  const omnibusData = getData(asyncSettingsOmnibus);
  const provider = getPersistedCallProvider();
  const isHubSpotProvider = getIsProviderHubSpot(provider);
  const phoneNumbers = getPhoneNumbers(omnibusData);
  const twilioAccountNumbers = getConnectAccountNumbers(phoneNumbers);

  // show when hubspot provider, globally disabled and no other third party/connect options
  const shouldShowCallingDisabled = useMemo(() => !getHubSpotCallingEnabled(omnibusData) && isHubSpotProvider && twilioAccountNumbers.size === 0, [isHubSpotProvider, omnibusData, twilioAccountNumbers.size]);

  // show when hubspot provider, no calling scopes and no other third party options
  const shouldShowFreeCalling = useMemo(() => isCallingFree(scopes) && isHubSpotProvider, [isHubSpotProvider, scopes]);
  const handleTracking = useCallback(() => {
    CommunicatorLogger.log('calling_callUpgradeClicked', {
      source: appIdentifier
    });
  }, [appIdentifier]);

  // show loading state
  if (isOmnibusDataUninitialized || isOmnibusDataLoading) return /*#__PURE__*/_jsx(CallNumberSkeletons, {});
  if (shouldShowCallingDisabled) return /*#__PURE__*/_jsx(GlobalCallingDisabled, {});
  if (shouldShowFreeCalling) {
    if (getCallingMinutesPerPortal(limits)) {
      return /*#__PURE__*/_jsx(UnlockCallingItem, {
        blockingType: "paid-seat-blocking",
        use: "popover",
        "data-test-id": "paid-seat-blocking-popover"
      });
    }
    return /*#__PURE__*/_jsx(UnlockCallingItem, {
      blockingType: "free-account-blocking",
      use: "popover",
      onTrack: handleTracking,
      "data-test-id": "free-account-blocking-popover"
    });
  }
  return children;
}
CallingOnboardingActivityCreator.propTypes = {
  asyncSettingsOmnibus: RecordPropType('AsyncSettingsOmnibusResult').isRequired,
  children: PropTypes.node.isRequired,
  scopes: ImmutablePropTypes.map.isRequired,
  appIdentifier: PropTypes.string.isRequired
};
export default /*#__PURE__*/memo(CallingOnboardingActivityCreator);